import { Box, Grid } from "@mui/material";

const Instrucciones = () => {
  return (
    <>
      <Box display='flex' flexDirection='column' alignItems='center' spacing={5}>
        <Grid container flexDirection='column' spacing={6}>
          <Grid item>
            <Grid container justifyContent='center' flexDirection="row" spacing={3}>
              <Grid item>
                <Box display='flex' flexDirection='column' alignItems='center'>
                  <img src="/images/instrucciones/instrucciones_ponencias.jpg" style={{ width: "100%" }} />
                </Box>
              </Grid>            
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Instrucciones;
